import HeaderBlock from './HeaderBlock';
import { HeaderBlockProps, HeaderBlockValueProps } from './types';

export type { HeaderBlockProps, HeaderBlockValueProps };
export default HeaderBlock;
